<template>
  <div class="default-layout">
    <AppHeader :key="'app-header'" />
    <slot></slot>
  </div>
</template>
